import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qgbeutab83: FaireBrandEntity = {
  token: "b_qgbeutab83",
  type: "brand",
  name: "Merigold",
  avatarUrl:
    "https://cdn.faire.com/fastly/b2c0285b83f23948523feed6b7fd5c0cd272d683c31065a7f94e01bcbab7d423.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/c7f9942642e23f7bfe290596ef43b24ceafe47f49d4d58d328d51720fa537e66.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b2c0285b83f23948523feed6b7fd5c0cd272d683c31065a7f94e01bcbab7d423.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c7f9942642e23f7bfe290596ef43b24ceafe47f49d4d58d328d51720fa537e66.jpeg",
  location: "Denver, CO, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 30,
  isTopShop: true,
  isInsider: true,
  description:
    "Merigold - All Natural, Clean Skincare. We are a skincare company focused on holistic wellness. Our flagship product is a powdered, facial mask. We believe in the power of nature to heal, so we create products with only organic and naturally occurring ingredients. Our products are designed for your skin’s best outcome and to help you take a moment of pause. \n\nAs a nurse, mother, natural food chef, and nutritionist, I’ve seen firsthand the toll constant striving takes on the body—it’s true, the body does keep the score. I started Merigold to empower women to take a pause with nourishing skincare products.\n\nI wanted clean skincare that was perfectly curated to be good for your body—and good for you.\n\nWith great love,\nHillary",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:17.692Z",
    importedBy: "entity-db-cli",
  },
};
